import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface GetCustomerEquipmentTypesRequestParams {
  TrailerKey: number;
  CustomerKey: number;
  CargoType: string;
}

export const getCustomerEquipmentTypesAPI = (params: GetCustomerEquipmentTypesRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetCustomerEquipmentTypes`,
  });
};

export type CustomerEquipmentTypesResponse = {
  trailerKey: number;
  description: string;
}[];

export const fetchCustomerEquipmentTypes = async (
  params: GetCustomerEquipmentTypesRequestParams,
): Promise<CustomerEquipmentTypesResponse> => {
  const response: AxiosResponse<CustomerEquipmentTypesResponse> = await getCustomerEquipmentTypesAPI(params);
  return response.data;
};
